import {
  Component,
  TemplateRef,
  ViewChild,
  ElementRef,
  OnInit
} from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { EventService } from '../event-service/event.service';

@Component({
  selector: 'app-ind-prov-modal',
  templateUrl: './ind-prov-modal.component.html',
  styleUrls: ['./ind-prov-modal.component.scss']
})
export class IndProvModalComponent implements OnInit {
  @ViewChild('template', { static: true }) public templateref: TemplateRef<any>;
  @ViewChild('nodeInput', { static: true }) nodeInput: ElementRef<HTMLElement>;

  modalRef: BsModalRef;
  public newForm: boolean;
  public num: number;
  blank: boolean = true;
  new: boolean;
  maintenance: boolean;
  resignation: boolean;
  private radioVal = { RESIGNATION: 3, MAINTENANCE: 2, NEW: 1 };

  constructor(private modalService: BsModalService,
              private eventService: EventService) { }

  ngOnInit() { }

  closeModal(): void {
    this.modalService.hide();
  }

  public openModalWithClass(reqType?: any): void {
    this.modalRef = this.modalService.show(
      this.templateref,
      Object.assign({}, { class: 'modal-lg', ignoreBackdropClick: true })
    );

    this.num = this.radioVal[reqType];

    if (reqType) {
      this.showForm(reqType);
    }
    else {
      this.blank = true;
      this.new = false;
      this.maintenance = false;
      this.resignation = false;

      this.eventService.request = null;
    }
  }

  public idType(text: string): void {}

  showForm(name: string): void {
    this.blank = false;
    this.new = false;
    this.maintenance = false;
    this.resignation = false;

    if (name === 'NEW') {
      this.new = true;
    }
    else if (name === 'MAINTENANCE') {
      this.maintenance = true;
    }
    else if (name === 'RESIGNATION') {
      this.resignation = true;
    }
    else {
      this.blank = true;
    }
  }
}
